<template>
  <svg class="ag-spark" :viewBox="`0 0 ${ancho} ${alto}`" :width="ancho" :height="alto" aria-hidden="true">
    <polyline v-if="area" :points="puntosArea" :fill="color" fill-opacity="0.12" stroke="none" />
    <polyline :points="puntos" fill="none" :stroke="color" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" />
    <circle v-if="ultimo" :cx="ultimo.x" :cy="ultimo.y" r="2.4" :fill="color" />
  </svg>
</template>

<script>
import { computed } from 'vue';
import { puntosSparkline } from '../../utils/analisisGastos';

export default {
  name: 'AgSparkline',
  props: {
    valores: { type: Array, default: () => [] },
    color: { type: String, default: '#1f6b45' },
    ancho: { type: Number, default: 72 },
    alto: { type: Number, default: 22 },
    area: { type: Boolean, default: true }
  },
  setup(props) {
    const puntos = computed(() => puntosSparkline(props.valores, props.ancho, props.alto, 3));
    const puntosArea = computed(() => {
      if (!puntos.value) return '';
      const pares = puntos.value.split(' ');
      const x0 = pares[0].split(',')[0];
      const x1 = pares[pares.length - 1].split(',')[0];
      return `${x0},${props.alto} ${puntos.value} ${x1},${props.alto}`;
    });
    const ultimo = computed(() => {
      if (!puntos.value) return null;
      const [x, y] = puntos.value.split(' ').pop().split(',');
      return { x, y };
    });
    return { puntos, puntosArea, ultimo };
  }
};
</script>

<style scoped>
.ag-spark { display: block; overflow: visible; }
</style>
